function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffd104;}.cls-2{fill:#98522c;}.cls-3{fill:#7d3f26;}.cls-4{fill:#ffdb32;}.cls-5{fill:#ffdf5c;}.cls-6{fill:#8e4a2c;}.cls-7{fill:#fbc205;}.cls-8{fill:#fff3c0;}.cls-9{fill:#ffe600;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M45.38,81.09a28.74,28.74,0,0,0-15,4.17v1.42H60.35V85.26A28.76,28.76,0,0,0,45.38,81.09Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 26.44,
  y: 86.68,
  width: 37.87,
  height: 23.67
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 23.83,
  y: 110.35,
  width: 43.1,
  height: 3.58
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.37,57.84a8.55,8.55,0,0,1-6,0h0A6.16,6.16,0,0,0,39.87,53l0,0A39,39,0,0,1,26.21,37h0A87.08,87.08,0,0,1,18,0H72.76a87.09,87.09,0,0,1-8.21,37h0A39,39,0,0,1,50.92,53l0,0a6.17,6.17,0,0,0-2.53,4.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M47.92,58a5.3,5.3,0,0,0,1.89,4.06h0a2,2,0,0,1-1.36,3.49H42.31a2,2,0,0,1-1.37-3.49h0A5.33,5.33,0,0,0,42.83,58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M50.48,82.81a18.18,18.18,0,0,1-10.2,0V79.42a25,25,0,0,0,1.62-13.91h6.93a26,26,0,0,0-.34,4.17,25.09,25.09,0,0,0,2,9.74v3.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26,52.28a5.85,5.85,0,0,1-3.81-1.41,2,2,0,0,1,2.66-3.1A1.7,1.7,0,0,0,26,48.2a1.76,1.76,0,0,0,1.76-1.77,1.92,1.92,0,0,0-.05-.41,5.9,5.9,0,0,0-1.52-2.58,2.6,2.6,0,0,1-.44-.41L7.94,26.28C2,20.73-2.31,12,1.34,5.13a9.49,9.49,0,0,1,8-5h.45a9.21,9.21,0,0,1,6.48,15.44,2,2,0,1,1-3-2.76,5.13,5.13,0,0,0-3.7-8.6A5.35,5.35,0,0,0,5,7C2.32,12,6.1,19,10.73,23.31l17.91,16.8.13.13.14.12A10.09,10.09,0,0,1,31.69,45v0a5.64,5.64,0,0,1,.18,1.42A5.85,5.85,0,0,1,26,52.28Zm-.2-9.2h0Zm1.68-3.27Zm0,0h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M58.88,46.43A6.13,6.13,0,0,1,59.05,45l0,0a9.92,9.92,0,0,1,2.78-4.6l.13-.12.13-.13L80,23.31C84.65,19,88.44,12,85.81,7a5.35,5.35,0,0,0-4.6-2.82,5.13,5.13,0,0,0-3.7,8.6,2,2,0,0,1-3,2.76A9.21,9.21,0,0,1,81,.14h.46a9.52,9.52,0,0,1,8,5c3.64,6.91-.69,15.6-6.61,21.15L65,43a2.47,2.47,0,0,1-.43.41A6,6,0,0,0,63,46a1.9,1.9,0,0,0,0,.41,1.76,1.76,0,0,0,1.76,1.77,1.72,1.72,0,0,0,1.15-.43,2,2,0,0,1,2.65,3.1,5.84,5.84,0,0,1-9.64-4.44Zm6-3.34h0Zm-1.66-3.28Zm0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M29.62,2.49H20.36a70.72,70.72,0,0,0,5.19,26.7,40,40,0,0,1-.77-7.79A39.19,39.19,0,0,1,29.62,2.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M26.44,110.35H64.31V86.68S51.66,110.35,26.44,110.35Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 31.57,
  y: 92.14,
  width: 27.62,
  height: 13.52
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M2.89,7.83a10.06,10.06,0,0,1,8.47-5.3h.49a9.72,9.72,0,0,1,3.05.59A8.27,8.27,0,0,0,9.57.93h-.4A8.53,8.53,0,0,0,2,5.4a11.68,11.68,0,0,0-.53,9.1A12.52,12.52,0,0,1,2.89,7.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M31.88,45.85a39,39,0,0,0,8,7.1l0,0a6.16,6.16,0,0,1,2.52,4.86h0a8.55,8.55,0,0,0,6,0h0A6.17,6.17,0,0,1,50.89,53l0,0A39,39,0,0,0,64.55,37h0A87.09,87.09,0,0,0,72.76,0C60.66,47.93,32,45.85,31.88,45.85Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 45.38,
  cy: 26.21,
  r: 12.76,
  transform: "translate(12.24 66.8) rotate(-80.78)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "4.91 226.9 47.83 171.46 30.46 171.46 56.26 131.61 25.35 131.61 3.63 182.45 21.51 182.45 4.91 226.9"
})));
function SvgIconTrophyLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.76 226.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono_trofeorayo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophyLightning);
export default __webpack_public_path__ + "static/media/icon-trophy_lightning.48d7275a182569b356115a63b3f3cb1f.svg";
export { ForwardRef as ReactComponent };